module.exports = __webpack_public_path__ + "catalog/items/firesafety/EmergencyLighting-HQ/EmergencyLighting-HQ.svg";